import gql from 'graphql-tag';

export const query = gql`
  query ApplicationEmails($input: ApplicationEmailsInput!) {
    applicationEmails(input: $input) {
      edges {
        node {
          id
          adcentreCandidateId
          prospectId
          to
          from
          subject
          message
          sentDate
        }
      }
    }
  }
`;
